import gsap from 'gsap';

class Form {
  constructor() {
    this.primaryButton = document.querySelector('.js-show-form');
    this.secondaryButtons = document.querySelectorAll('.js-show-form-secondary');
    this.formElement = document.querySelector('.js-tne-form');
    this.formContainer = document.querySelector('.tne__mailchimp-form__mod');
    this.tl = gsap.timeline();

    // Bind
    this.primaryButton.addEventListener('click', this.handleClick.bind(this));
    this.secondaryButtons.forEach(el => {
      el.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick() {
    // toggle class
    if (!this.formElement.classList.contains('js-contact-form--open')) {
      this.formElement.classList.toggle('js-contact-form--open');
    }

    // fade out primary button (no matter which button has been clicked)
    this.tl.to(this.primaryButton, {
      duration: 0.4,
      ease: 'power3.in',
      css: {
        autoAlpha: 0,
      },
    });

    this.formElement.scrollIntoView({ behavior: 'smooth' });
    this.tl.to(this.formElement, {
      duration: 0.8,
      delay: -0.2,
      ease: 'power3.out',
      css: {
        height: 'auto',
        autoAlpha: 1,
        display: 'block',
        translateY: '0',
      },
      onComplete: () => {
        document.getElementById('mce-EMAIL').focus();
      },
    });
  }
}

export default Form;
